import { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { useAppearance } from './AppearanceProvider';
import './motion-scene.css';

// Perspective and light move on composited layers. No scroll hijacking or WebGL.
export default function MotionScene({ variant = 'portal', className = '' }) {
  const root = useRef(null), reduced = useReducedMotion();
  const { preferences } = useAppearance();
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (!root.current || typeof IntersectionObserver !== 'function') return;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting));
    observer.observe(root.current); return () => observer.disconnect();
  }, []);
  return <div ref={root} className={`tl-motion-scene is-${variant} ${className}`} data-scene-active={visible && !reduced && !preferences.quiet} aria-hidden="true">
    <div className="tl-scene-haze"/><div className="tl-scene-plane"/>
    <div className="tl-scene-orbits">{[0,1,2,3].map(index => <i key={index} style={{'--orbit-index':index}}/>)}</div>
    <svg className="tl-scene-signal" viewBox="0 0 600 380" fill="none">
      <path className="tl-scene-path" pathLength="1" d="M45 267C90 273 102 216 145 229S203 282 249 221S298 148 339 178S408 132 449 148S503 100 552 104"/>
      <path className="tl-scene-baseline" d="M45 306H555M45 74V306M45 190H555"/>
      {[103,168,238,308,378,448,518].map((x,index)=><g className="tl-scene-candle" key={x} style={{'--candle-index':index}}><path d={`M${x} ${220-index*17}v64`}/><rect x={x-5} y={235-index*17} width="10" height="30" rx="1"/></g>)}
    </svg>
  </div>;
}
